import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles/";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { clearCart } from "../../redux/reducers/cart.reducer";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import moment from "moment";
import ConfirmationDialog from "../../components/ConfirmationDialog";
import { algoliaClient } from "../../utils/constants";
import firebase from "firebase";
import { toast as Toast } from "react-toastify";
import SaveCartModal from "../../components/cart/SaveCartModal";
import EmptyComponentRender from "../../components/EmptyComponentRender";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faTrash } from "@fortawesome/free-solid-svg-icons";
import FullScreenLoading from "../../components/FullScreenLoading";
import { isMobile } from "react-device-detect";
import CartScreen from "./CartScreen";
import customTheme from "../../utils/ui";
const algoliaIndex = algoliaClient.initIndex("products");
const index = algoliaClient.initIndex("stores");

const useStyles = makeStyles({
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    width: "100%",
    padding: 5,
  },
  categories: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    margin: 20,
  },
  fabRight: {
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    // position: 'absolute',
    //bottom: 20,
    right: -30,
  },
  fabLeft: {
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    //   position: 'absolute',
    // bottom: 20,
  },
  listHeader: {
    padding: 10,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderRightWidth: 1,
    textAlign: "center",
    fontWeight: "600",
    fontSize: 20,
    borderRightColor: "#dfe4fe",
  },
  gridStyle: {
    width: "100%",
    marginTop: 20,
  },
  images: {
    margin: "auto",
    width: 45,
    height: 45,
    resizeMode: "contain",
  },
  info: {
    marginTop: 5,
    marginBottom: 5,
  },
  infoText: {
    textAlign: "center",
  },
});

const ComparingCart = () => {
  const [loading, setLoading] = useState(false);
  const [showSaveCartModal, setShowSaveCartModal] = useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [totals, setTotals] = React.useState([0, 0, 0, 0, 0, 0, 0, 0]);
  const [productsData, setProductsData] = useState([]);
  const [storesData, setStoresData] = useState([]);
  const { t } = useTranslation();
  const params = useParams();
  const theme = useTheme();
  const userInfo = useSelector((state) => state.auth.user);
  const products = useSelector((state) => {
    console.log("params && params?.id ?? ", params && params?.id);
    console.log("state.cart.products?? ", state.cart.products);
    if (params && params?.id) {
      console.log("compare : : ", state);
      const comapre = state.comparesList.comparesList.find(
        (item) => item.id === params.id
      );
      if (comapre && comapre.products && comapre.products.length > 0) {
        return comapre.products;
      } else {
        return [];
      }
    } else {
      return state.cart.products;
    }
  });
  const stores = useSelector((state) => state.stores.selectedStores);
  const selectedEmirate = useSelector(
    (state) => state.emiratesAndRegion.selectedEmirates
  );
  const dispatch = useDispatch();
  const styles = useStyles();
  const { innerWidth: width, innerHeight: height } = window;
  const vw = width / 100;
  const vh = height / 100;

  useEffect(() => {
    (async () => {
      setLoading(true);
      await loadDataFromAlgolia();
      await loadData();
      setLoading(false);
    })();
  }, [products, stores]);

  const handleShowSaveCartModal = (shouldShow) => {
    if (!userInfo?.isAnonymous) {
      setShowSaveCartModal(shouldShow);
    } else if (userInfo?.isAnonymous) {
      Toast.error(`Oops!! ${t("users.loginAsNormalUser")}`);
    }
  };
  const filterCompare = async (options) => {
    return await algoliaIndex.search("", {
      facetFilters: [[...options]],
      facets: ["*"],
    });
  };

  const loadData = async () => {
    if (stores && stores.length <= 0) {
      if (!selectedEmirate || selectedEmirate === []) {
        const storesList = await (
          await firebase.firestore().collection("stores").get()
        ).docs.map((item) => item.data());
        setStoresData(storesList.length > 0 ? storesList : []);
        setTotals(storesList.map((i) => 0).slice(0, 9));
      } else {
        const storesSearch =
          stores && stores.length > 0
            ? stores.map((storeId) => `id:${storeId}`)
            : [];
        const emirateSearch = selectedEmirate?.map(
          (emirate) => `emarite:${emirate}`
        );
        const facts =
          storesSearch?.length > 0 && emirateSearch?.length > 0
            ? [storesSearch, emirateSearch]
            : storesSearch?.length > 0 && emirateSearch?.length <= 0
            ? [storesSearch]
            : storesSearch?.length <= 0 && selectedEmirate
            ? [emirateSearch]
            : [];
        await index
          .search("", {
            facetFilters: facts,
            facets: ["*"],
          })
          .then((results) => {
            setStoresData(results.hits);
          })
          .catch((err) => {
            console.log(" eerr : ", err);
            Toast.error(
              "Could not retrieve any search records, Please try again later."
            );
          });
      }
    } else {
      const storesList = await (
        await firebase
          .firestore()
          .collection("stores")
          .where("id", "in", stores)
          .get()
      ).docs.map((item) => item.data());
      setStoresData(storesList);
    }
  };

  const calcProductAfterDiscount = (data) => {
    if (data.currentDiscountExpiry && data.currentDiscountExpiry != null) {
      const exp = data.currentDiscountExpiry;
      const isValid = moment(new Date()).isSameOrBefore(exp);
      const diff = moment().diff(exp, "days");

      console.log("isAfter : ", isValid);
      console.log("diff : ", diff);

      if (!isValid) {
        return data.price;
      }
    }

    if (data.discount && Number(data.discount) > 0) {
      const priceAfterDiscount =
        data.price - data.price * (Number(data.discount) / 100);
      return priceAfterDiscount;
    } else {
      return data.price;
    }
  };
  const loadDataFromAlgolia = async () => {
    if (products && products.length > 0) {
      let items = [];
      const options = products.map((p) => `id:${p.id}`);
      const productsDetails = await filterCompare(options);
      await productsDetails?.hits?.forEach(async (product) => {
        const storesSearch =
          stores && stores.length > 0
            ? stores.map((storeId) => `store:${storeId}`)
            : [];
        const facts =
          storesSearch && storesSearch.length > 0
            ? [
                storesSearch,
                [`category:${product.category}`],
                [`brand:${product.brand}`],
                [`sizeOrCapacity:${product.sizeOrCapacity}`],
                [`measureUnit:${product.measureUnit}`],
              ]
            : [
                [`category:${product.category}`],
                [`brand:${product.brand}`],
                [`sizeOrCapacity:${product.sizeOrCapacity}`],
                [`measureUnit:${product.measureUnit}`],
              ];
        const results = await algoliaIndex.search("", {
          facetFilters: facts,
          facets: ["*"],
        });
        const cartProduct = products.find((p) => p.id === product.id);
        const productData = {
          ...product,
          ...cartProduct,
          priceAfterDiscount: calcProductAfterDiscount(product),
          priceList:
            results?.hits?.map((item) => {
              const priceAfterDiscount = calcProductAfterDiscount(product);
              return {
                price: priceAfterDiscount ?? item.price,
                storeInfo: { ...item.storeInfo, id: item.store },
              };
            }) ?? [],
        };
        items.push(productData);
      });
      setProductsData(items);
    } else {
      setProductsData([]);
    }
  };

  const handleClearCart = () => {
    setShowConfirmationDialog(true);
  };

  const _clearCart = () => {
    dispatch(clearCart());
    setShowConfirmationDialog(false);
  };

  const RenderResults = ({}) => {
    let total = [];
    if (storesData && productsData) {
      storesData.forEach((store) => {
        let storeTotals = { total: 0, totalUnAvailable: 0 };
        productsData.forEach((p) => {
          if (p && p.priceList) {
            const isSelling = p.priceList.find(
              (price) => price.storeInfo.id == store.id
            );
            if (isSelling) {
              const price = !!isSelling.price
                ? isSelling.price * p.cartQuantity
                : 0;
              storeTotals.total = storeTotals.total + price;
            } else {
              const price =
                !!p.priceList[0] && !!p.priceList[0].price
                  ? p.priceList[0].price * p.cartQuantity
                  : 0;
              storeTotals.totalUnAvailable =
                storeTotals.totalUnAvailable + price;
            }
          }
        });
        total.push({
          ...storeTotals,
          storeInfo: {
            image: store.image ?? "",
            id: store.id,
            nameEn: store.nameEn ?? "",
            nameAr: store.nameAr ?? "",
          },
        });
      });
      const lowestToHighest =
        total
          .filter((item) => item.total > 0)
          .sort(function (a, b) {
            return (
              a.total + a.totalUnAvailable - (b.total + b.totalUnAvailable)
            );
          }) ?? [];
      return (
        <Grid
          container
          spacing={2}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            width: "100%",
          }}
        >
          <Grid
            item
            xs={isMobile ? 12 : 6}
            style={{ display: "flex", width: "100%", flexDirection: "column" }}
          >
            {!!lowestToHighest &&
              lowestToHighest.length > 0 &&
              lowestToHighest.slice(0, 3).map((item, i) => {
                return (
                  <Grid
                    item
                    xs={12}
                    key={"results card" + i}
                    style={{
                      display: "flex",
                      minHeight: 50,
                      marginTop: 10,
                      borderStyle: "solid",
                      borderColor: "#dfe4fe",
                      borderWidth: 1,
                      paddingRight: 20,
                      paddingLeft: 20,
                      borderRadius: 25,
                      flexDirection: "row",
                    }}
                  >
                    <div
                      className={styles.info}
                      style={{
                        display: "flex",
                        height: 50,
                        minHeight: 50,
                        flexDirection: "row",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      <Typography
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          alignSelf: "center",
                          textAlign: "center",
                          color: "green",
                          fontWeight: "bold",
                          paddingTop: 5,
                          fontSize: isMobile ? 10 : 15,
                        }}
                      >
                        <Typography
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            color: "green",
                            fontWeight: "bold",
                            fontSize: isMobile ? 10 : 15,
                          }}
                        >
                          {(() => {
                            let order = "st";
                            switch (i) {
                              case 0:
                                order = "1st";
                                break;
                              case 1:
                                order = "2nd";
                                break;
                              case 2:
                                order = "3rd";
                                break;

                              default:
                                break;
                            }
                            return order;
                          })()}
                          <div
                            style={{
                              display: "flex",
                              paddingLeft: 5,
                              paddingRight: 5,
                              flexDirection: "row",
                            }}
                          >
                            <Typography
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                fontWeight: "bold",
                                fontSize: isMobile ? 10 : 15,
                              }}
                            >
                              {`  Lowest Shop Price : `}
                            </Typography>

                            <div
                              style={{
                                paddingLeft: 5,
                                paddingRight: 5,
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <Typography
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  fontWeight: "bold",
                                  fontSize: isMobile ? 10 : 15,
                                }}
                              >
                                {item.total}{" "}
                              </Typography>

                              <Typography
                                style={{
                                  paddingLeft: 5,
                                  paddingRight: 5,
                                  display: "flex",
                                  flexDirection: "row",
                                  color: "green",
                                  fontWeight: "bold",
                                  fontSize: isMobile ? 10 : 15,
                                }}
                              >
                                {t("product.currency")}
                              </Typography>
                            </div>
                          </div>
                        </Typography>
                      </Typography>
                      {!!item.storeInfo.image && (
                        <div
                          className={styles.images}
                          style={{ marginLeft: 10, height: 35, width: 35 }}
                        >
                          <img
                            src={item.storeInfo.image}
                            className={styles.images}
                            style={{ height: 35, width: 35 }}
                          />
                        </div>
                      )}
                    </div>
                  </Grid>
                );
              })}
          </Grid>
          <Grid
            item
            xs={isMobile ? 12 : 6}
            style={{
              height: 100,
              display: "flex",
              width: "100%",
              flexDirection: "column",
            }}
          >
            <Grid
              item
              xs={12}
              key={"highest card"}
              style={{
                display: "flex",
                marginTop: 10,
                borderStyle: "solid",
                borderColor: "#dfe4fe",
                borderWidth: 1,
                paddingRight: 20,
                paddingLeft: 20,
                borderRadius: 25,
                flexDirection: "row",
              }}
            >
              <div
                className={styles.info}
                style={{
                  height: 50,
                  minHeight: 50,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Typography
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    alignSelf: "center",
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: isMobile ? 10 : 15,
                  }}
                >
                  {`  Highest Shop Price : `}
                  <Typography
                    style={{
                      paddingLeft: 5,
                      paddingRight: 5,
                      dispaly: "flex",
                      flexDirection: "row",
                      fontWeight: "bold",
                      color: theme.dark.primary,
                      fontSize: isMobile ? 10 : 15,
                    }}
                  >
                    {`${
                      lowestToHighest &&
                      lowestToHighest[lowestToHighest.length - 1] &&
                      lowestToHighest[lowestToHighest.length - 1].total
                        ? lowestToHighest[lowestToHighest.length - 1].total
                        : "0"
                    }  
                                 
                                 ${t("product.currency")}`}
                  </Typography>
                </Typography>
                {!!lowestToHighest &&
                !!lowestToHighest[lowestToHighest.length - 1] &&
                !!lowestToHighest[lowestToHighest.length - 1].storeInfo &&
                !!lowestToHighest[lowestToHighest.length - 1].storeInfo
                  .image ? (
                  <div
                    className={styles.images}
                    style={{ marginLeft: 10, height: 35, width: 35 }}
                  >
                    <img
                      src={
                        lowestToHighest[lowestToHighest.length - 1].storeInfo
                          .image
                      }
                      className={styles.images}
                      style={{ height: 35, width: 35 }}
                    />
                  </div>
                ) : (
                  <Typography
                    style={{
                      dispaly: "flex",
                      flexDirection: "row",
                      fontWeight: "bold",
                      fontSize: isMobile ? 10 : 15,
                    }}
                  >
                    {lowestToHighest &&
                    lowestToHighest[lowestToHighest.length - 1] &&
                    !!lowestToHighest[lowestToHighest.length - 1].storeInfo &&
                    !!lowestToHighest[lowestToHighest.length - 1].storeInfo
                      .nameEn
                      ? lowestToHighest[lowestToHighest.length - 1].storeInfo
                          .nameEn
                      : ""}{" "}
                  </Typography>
                )}
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              key={"saveing card"}
              style={{
                display: "flex",
                marginTop: 10,
                borderStyle: "solid",
                borderColor: "#dfe4fe",
                borderWidth: 1,
                paddingRight: 20,
                paddingLeft: 20,
                borderRadius: 25,
                flexDirection: "row",
              }}
            >
              <div
                className={styles.info}
                style={{
                  height: 50,
                  minHeight: 50,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Typography
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: isMobile ? 10 : 15,
                  }}
                >
                  {`  Your Savings : `}
                  <Typography
                    style={{
                      paddingLeft: 5,
                      paddingRight: 5,
                      dispaly: "flex",
                      flexDirection: "row",
                      fontWeight: "bold",
                      color: "green",
                      fontSize: isMobile ? 10 : 15,
                    }}
                  >
                    {`${
                      lowestToHighest &&
                      lowestToHighest[lowestToHighest.length - 1] &&
                      lowestToHighest[lowestToHighest.length - 1].total
                        ? lowestToHighest[lowestToHighest.length - 1].total -
                          lowestToHighest[0].total
                        : "0"
                    } 
                              
                                        ${t("product.currency")}`}
                  </Typography>
                </Typography>
              </div>
            </Grid>

            <div style={{ height: height - vh * 85 }} />
          </Grid>
          <Grid
            item
            xs={12}
            key={"buttons"}
            style={{
              display: "flex",
              marginTop: isMobile ? 60 : 10,
              paddingRight: 20,
              paddingLeft: 20,
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Button
              className={styles.fabRight}
              style={{ backgroundColor: theme.dark.dark }}
              size="large"
              //color={theme.dark.primary}
              //icon="delete"
              onClick={handleClearCart}
            >
              Delete
              <FontAwesomeIcon
                style={{ paddingLeft: 7, paddingRight: 7, fontSize: 16 }}
                icon={faTrash}
              />
            </Button>
            <Button
              className={styles.fabLeft}
              style={{ backgroundColor: theme.dark.dark }}
              size="large"
              //color={theme.dark.primary}
              // icon="content-save-outline"
              onClick={() => handleShowSaveCartModal(true)}
            >
              Save
              <FontAwesomeIcon
                style={{ paddingLeft: 7, paddingRight: 7, fontSize: 16 }}
                icon={faSave}
              />
            </Button>
          </Grid>
        </Grid>
      );
    } else {
      return <></>;
    }
  };

  if (loading) {
    return <FullScreenLoading />;
  }

  if (!loading && (!productsData || productsData.length == 0)) {
    return <EmptyComponentRender />;
  }

  return (
    <>
        <div style={{
            backgroundColor: customTheme.light.primary,
            borderRadius: 10,
            opacity: 0.7,
            padding: 15,
            marginBottom: 10,
            display: 'flex',
            alignItems: 'center',
            alignSelf: 'center',
            justifyContent: 'center',
            alignContent: 'center'
        }}>
            <Typography>{t('general.cartHint')}</Typography>
        </div>
      <ConfirmationDialog
        visible={showConfirmationDialog}
        title={"cart.clearCartTitle"}
        body={"cart.clearCartBody"}
        hideDialog={() => setShowConfirmationDialog(false)}
        confirmCb={_clearCart}
      />
      <SaveCartModal
        userInfo={userInfo}
        isAnonymous={userInfo?.isAnonymous}
        visible={showSaveCartModal}
        title={"cart.clearCartTitle"}
        body={"cart.clearCartBody"}
        hideDialog={() => setShowSaveCartModal(false)}
        confirmCb={() => {}}
      />
      <CartScreen
        storesData={storesData}
        productsData={productsData}
        styles={styles}
        totals={totals}
      />
      <RenderResults />
    </>
  );
};

export default ComparingCart;
